import PaymentRequestsHeaderAdditional from './index.vue'
export default PaymentRequestsHeaderAdditional